import { language as lan_en } from "./en/index"
import { language as lan_zh_CN } from "./zh_CN/index"

/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 * 
 * @summary 这个文件也是临时使用的，后续做多语言的时候，会根据选择语言下载相应的文件
 */
let languages = {
    en: {
        /**
         * 多语言Key Value
         */
        ...lan_en
    },
    zh_CN: {
        /**
         * 多语言Key Value
         */
        ...lan_zh_CN
    }
}


export { languages }
